// Mirrors `offer_value` in presentation-api's SubmitOfferBody
// (src/routers/offers/schema.ts) — the regex plus a `> 0` refine. Both offer
// submission and the v2 price-quote validate against it, so keep the two in sync.
const OFFER_VALUE_PATTERN = /^\d+(\.\d+)?$/;

export function isValidOfferValue(value: string): boolean {
  return OFFER_VALUE_PATTERN.test(value) && Number(value) > 0;
}
